import { ItemBiddingEntity } from "@hds-products/event-runtime-entities-common";
import { FrankServiceEntityPersistence } from "@hds/entity-lib";

class ItemBiddingClientEntity extends ItemBiddingEntity {
    constructor(ep, seedData = {}, options = {}) {
        super(ep, seedData, options);
    }
    static createInstance(baseUri, seedData, customHeaderFn) {
        const ep = ItemBiddingClientEntity.createEntityPersistence(baseUri, customHeaderFn);
        return new ItemBiddingClientEntity(ep, seedData);
    }
    static createEntityPersistence(baseUri, customHeaderFn) {
        const ep = new FrankServiceEntityPersistence(baseUri, ItemBiddingClientEntity.prototype._meta.entityName, customHeaderFn);
        return ep;
    }
    /*****************************************************/
    // START OVERRIDDEN PROPERTIES
    /*****************************************************/
    set activeBidders(newActiveBidders) {
        throw new Error('SET_PROPERTY_NOT_ALLOWED');
    }
    set badge(badge) {
        throw new Error('SET_PROPERTY_NOT_ALLOWED');
    }
    set bid(newBid) {
        throw new Error('SET_PROPERTY_NOT_ALLOWED');
    }
    set bidType(newBidType) {
        throw new Error('SET_PROPERTY_NOT_ALLOWED');
    }
    set buyNowAmount(newBuyNowAmount) {
        throw new Error('SET_PROPERTY_NOT_ALLOWED');
    }
    set buyNowDisableThreshold(newBuyNowDisableThreshold) {
        throw new Error('SET_PROPERTY_NOT_ALLOWED');
    }
    set estimatedTime(newEstimatedTime) {
        throw new Error('SET_PROPERTY_NOT_ALLOWED');
    }
    set eventDetailId(newEventDetailId) {
        throw new Error('SET_PROPERTY_NOT_ALLOWED');
    }
    set expectedFinalizationStatus(newExpectedFinalizationStatus) {
        throw new Error('SET_PROPERTY_NOT_ALLOWED');
    }
    set increment(increment) {
        throw new Error('SET_PROPERTY_NOT_ALLOWED');
    }
    set lastUpdatedRawEntryId(newLastUpdatedRawEntryId) {
        throw new Error('SET_PROPERTY_NOT_ALLOWED');
    }
    set paused(newPaused) {
        throw new Error('SET_PROPERTY_NOT_ALLOWED');
    }
    set proxyBids(newProxyBids) {
        throw new Error('SET_PROPERTY_NOT_ALLOWED');
    }
    set status(newStatus) {
        throw new Error('SET_PROPERTY_NOT_ALLOWED');
    }
    /*****************************************************/
    // END OVERRIDDEN PROPERTIES
    // START OVERRIDDEN METHODS
    /*****************************************************/
    appendEntry() { throw new Error('METHOD_NOT_ALLOWED'); }
    create() { throw new Error('METHOD_NOT_ALLOWED'); }
    upsert() { throw new Error('METHOD_NOT_ALLOWED'); }
    update() { throw new Error('METHOD_NOT_ALLOWED'); }
    patch() { throw new Error('METHOD_NOT_ALLOWED'); }
    replace() { throw new Error('METHOD_NOT_ALLOWED'); }
    delete() { throw new Error('METHOD_NOT_ALLOWED'); }
    /*****************************************************/
    // END OVERRIDDEN METHODS
    /*****************************************************/
}

export { ItemBiddingClientEntity };
export default ItemBiddingClientEntity;